export default "__VITE_ASSET__c22216a9__"